'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _signupOrLoginButton = require('./common/signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
    _inherits(Evernote, _React$Component);

    function Evernote() {
        _classCallCheck(this, Evernote);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(Evernote).apply(this, arguments));
    }

    _createClass(Evernote, [{
        key: 'renderSignupButton',
        value: function renderSignupButton() {
            return _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, this.props, {
                buttonText: 'Sign in to HelloSign Integrations Page',
                homeUrl: '/home/myAccount#integrations',
                redirectUrl: 'L2hvbWUvbXlBY2NvdW50I2ludGVncmF0aW9ucw==',
                signupUrl: 'L2hvbWUvbXlBY2NvdW50I2ludGVncmF0aW9ucw==',
                googleOpenIdUrl: this.props.googleOpenIdLocationUrl,
                buttonClass: 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button',
                isIntegration: true,
                buttonTextColor: 'white',
                buttonColor: 'cerulean',
                buttonBorderColor: 'cerulean',
                buttonHoverColor: 'cerulean',
                buttonHoverTextColor: 'white'
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: 'seo-cloud-integrations'
            }, void 0, _jsx('div', {
                className: 'top row evernote-green'
            }, void 0, _jsx('div', {
                className: 'top-content-container large-5 large-push-6 columns'
            }, void 0, _jsx('div', {
                className: 'hellosign-dropbox'
            }, void 0, _jsx('img', {
                src: require("../assets/HS_logo_white.svg"),
                alt: 'HelloSign Logo',
                className: 'hs-logo'
            }), _jsx('span', {
                className: 'plus'
            }, void 0, '+'), _jsx('img', {
                src: require("../assets/evernote_logo_white.svg"),
                alt: 'Dropbox Logo',
                className: 'dropbox-logo',
                width: '130'
            })), _jsx('div', {
                className: 'title'
            }, void 0, _jsx('h1', {}, void 0, 'Access Evernote Documents in HelloSign')), _jsx('div', {
                className: 'subtitle'
            }, void 0, _jsx('h2', {}, void 0, 'Use the HelloSign + Evernote integration to access notes in HelloSign and store copies of signed documents in your Evernote account.')), _jsx('div', {
                className: 'signup-button'
            }, void 0, this.renderSignupButton())), _jsx('div', {
                className: 'clouds-container large-5 large-pull-4 columns'
            }, void 0, _jsx('img', {
                src: require("../assets/clouds_evernote.svg"),
                alt: 'cloud left'
            })), _jsx('img', {
                src: require("../assets/cloud_left.svg"),
                alt: 'cloud left',
                className: 'cloud-left'
            }), _jsx('img', {
                src: require("../assets/cloud_right.svg"),
                alt: 'cloud right',
                className: 'cloud-right'
            })), _jsx('div', {
                className: 'seo-cloud-integrations__main'
            }, void 0, _jsx('div', {
                className: 'seo-cloud-integrations__main__free_accounts__top'
            }, void 0, _jsx('p', {}, void 0, 'Free accounts include three documents a month.'), _jsx('p', {}, void 0, 'Upgrade to a business plan for unlimited documents. ', _jsx('a', {
                href: '/info/pricing'
            }, void 0, 'See Pricing Page'), '.')), _jsx('div', {
                className: 'seo-cloud-integrations__benefits'
            }, void 0, _jsx('h2', {}, void 0, 'Benefits'), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('section', {
                className: 'access-dropbox-from-hs large-4 columns'
            }, void 0, _jsx('div', {
                className: 'benefits-image-container'
            }, void 0, _jsx('img', {
                src: require("../assets/folder_icon.svg"),
                alt: 'folder icon'
            })), _jsx('h3', {}, void 0, 'Access Evernote notebooks in your HelloSign account'), _jsx('p', {}, void 0, 'View documents from your Evernote notebooks in your HelloSign account. Select a note and you’re all set to start preparing your doc for signature.')), _jsx('section', {
                className: 'sign-any-from-dropbox large-4 columns'
            }, void 0, _jsx('div', {
                className: 'benefits-image-container'
            }, void 0, _jsx('img', {
                src: require("../assets/signature_icon.svg"),
                alt: 'signature icon'
            })), _jsx('h3', {}, void 0, 'Send notes for signature request in HelloSign'), _jsx('p', {}, void 0, 'Prepare your notes for signature with a few quick clicks. Send your signature request and you’re almost there!')), _jsx('section', {
                className: 'save-signed-copies large-4 columns end'
            }, void 0, _jsx('div', {
                className: 'benefits-image-container'
            }, void 0, _jsx('img', {
                src: require("../assets/cloud_icon.svg"),
                alt: 'cloud icon'
            })), _jsx('h3', {}, void 0, 'Automatically sync signed documents in your Evernote notebook'), _jsx('p', {}, void 0, 'Once your document is signed, a copy of the completed document will sync to your Evernote account. Easy storage.')))), _jsx('div', {
                className: 'seo-cloud-integrations__how-it-works'
            }, void 0, _jsx('h2', {}, void 0, 'How it Works'), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'screenshot-explanation large-3 large-push-9 columns'
            }, void 0, _jsx('p', {}, void 0, 'To sync your HelloSign account with Evernote, just click the Evernote icon the next time you upload a document to be signed.'), _jsx('p', {}, void 0, 'Once you are synced, you can click on the Evernote icon whenever you need to pull a file from your Evernote account to request a signature or sign and send.')), _jsx('div', {
                className: 'dropbox-screenshot large-9 large-pull-3 columns'
            }, void 0, _jsx('img', {
                src: require("../assets/screenshot_evernote.png"),
                alt: 'screenshot evernote'
            })))), _jsx('div', {
                className: 'seo-cloud-integrations__quote-container'
            }, void 0, _jsx('p', {
                className: 'quote'
            }, void 0, '"We\'re particularly excited about our partnership with HelloSign because we both believe in the importance of a simple, yet powerful user experience."'), _jsx('p', {
                className: 'quote-name'
            }, void 0, 'MEGHAN KEANEY ANDERSON'), _jsx('p', {
                className: 'quote-title'
            }, void 0, 'Product Marketing Director at HubSpot')), _jsx('div', {
                className: 'seo-cloud-integrations__social'
            }, void 0, _jsx('a', {
                href: 'https://twitter.com/intent/tweet?text=Integrate%20%40Evernote%20with%20%40HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20documents%20in%20%23Evernote.&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Devernote-integration-page-s2s'
            }, void 0, _jsx('img', {
                src: require("../assets/social_twitter@2x.png"),
                alt: 'twitter share link'
            })), _jsx('a', {
                href: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Devernote-integration-page-s2s'
            }, void 0, _jsx('img', {
                src: require("../assets/social_facebook@2x.png"),
                alt: 'facebook share link',
                className: 'facebook-share'
            })), _jsx('a', {
                href: 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Devernote-integration-page-s2s&title=Integrate%20Evernote%20%26%20HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20docs%20in%20Evernote&source=https%253A%252F%252Fwww.hellosign.com%252Fevernote'
            }, void 0, _jsx('img', {
                src: require("../assets/social_linkedin@2x.png"),
                alt: 'linkedin share link'
            }))), _jsx('div', {
                className: 'seo-cloud-integrations__faq'
            }, void 0, _jsx('p', {}, void 0, 'Questions about this integration? We have answers.'), _jsx('button', {
                className: 'm-button bg-cerulean  hbg-castle-rock c-white progress-button state-loading m-login-or-signup--sign-up-button'
            }, void 0, _jsx('span', {
                className: 'l-nowrap'
            }, void 0, _jsx('a', {
                href: 'https://faq.hellosign.com/hc/en-us/sections/200998238-Evernote',
                className: 'faq-link'
            }, void 0, 'VIEW OUR FAQ')))), _jsx('div', {
                className: 'seo-cloud-integrations__main__free_accounts__bottom'
            }, void 0, _jsx('p', {}, void 0, 'Free accounts include three documents a month.'), _jsx('p', {}, void 0, 'Upgrade to a business plan for unlimited documents. ', _jsx('a', {
                href: '/info/pricing'
            }, void 0, 'See Pricing Page'), '.'))));
        }
    }]);

    return Evernote;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/evernote.jsx
 ** module id = 849
 ** module chunks = 0
 **/